<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="[
          { 'md-valid': !errors.has('specialization') && touched.specialization },
          { 'md-error': errors.has('specialization') }
        ]">
        <label for="specialization">Eye Care Provider</label>
        <md-select v-validate="'required'" v-model="specialization" name="specialization" data-vv-name="specialization">
          <md-option v-for="(item, index) in specializationList" :key="item.LookupId" :value="item.LookupId">
            {{ item.Value }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="[
          { 'md-valid': !errors.has('subspecialization') && touched.subspecialization },
          { 'md-error': errors.has('subspecialization') }
        ]">
        <label for="subspecialization">Eye Care Specialty</label>
        <md-select
          v-validate="'required'"
          v-model="subspecialization"
          name="subspecialization"
          data-vv-name="subspecialization"
        >
          <md-option v-for="(item, index) in subspecializationsList" :key="item.LookupId" :value="item.LookupId">
            {{ item.DisplayValue }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="[
          { 'md-valid': !errors.has('specialties') && touched.specialties },
          { 'md-error': errors.has('specialties') }
        ]">
        <label for="specialties">Non-Eye Care Provider</label>
        <md-select v-validate="'required'" v-model="specialties" name="specialties" data-vv-name="specialties">
          <md-option v-for="(item, index) in specialtiesList" :key="item.LookupId" :value="item.LookupId">
            {{ item.DisplayValue }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field :class="[
          { 'md-valid': !errors.has('boardCertified') && touched.boardCertified },
          { 'md-error': errors.has('boardCertified') }
        ]">
        <label for="boardCertified">Are you Board Certified?</label>
        <md-select v-validate="'required'" v-model="boardCertified" name="boardCertified" data-vv-name="boardCertified">
          <md-option value="Yes">Yes, I am Board Certified</md-option>
          <md-option value="No">No, I am not Board Certified</md-option>
          <md-option value="Pending">My Board Certification is pending</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field :class="[
          { 'md-valid': !errors.has('certdate') && touched.certdate },
          { 'md-error': errors.has('certdate') }
        ]">
        <md-icon>today</md-icon>
        <label for="certdate">Certification Date</label>
        <md-input
          v-validate="{ required: boardCertified.toLowerCase() === 'yes' }"
          id="certdate"
          v-model="certdate"
          placeholder=" "
          data-vv-name="certdate"
          name="certdate"
          type="date"
        />
      </md-field>
    </div>

    <div class="md-layout-item md-size-80 mt-4 md-small-size-100">
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
          <md-field :class="[
              { 'md-valid': !errors.has('CAQH') && touched.CAQH },
              { 'md-error': errors.has('CAQH') }
            ]">
            <md-icon>verified_user</md-icon>
            <label>CAQH Number #</label>
            <md-input v-model="CAQH" data-vv-name="CAQH" type="text" name="CAQH" />
          </md-field>
        </div>

        <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
          <md-field :class="[
              { 'md-valid': !errors.has('NPI') && touched.NPI },
              { 'md-error': errors.has('NPI') }
            ]">
            <md-icon>verified_user</md-icon>
            <label>NPI Number #</label>
            <md-input v-model="NPI" data-vv-name="NPI" type="text" name="NPI" />
          </md-field>
        </div>

        <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
          <md-field :class="[
              { 'md-valid': !errors.has('License') && touched.License },
              { 'md-error': errors.has('License') }
            ]">
            <md-icon>verified_user</md-icon>
            <label>License Number #</label>
            <md-input v-model="License" data-vv-name="License" type="text" name="License" />
          </md-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      modelValidations: {
        CAQH: { required: false, min: 0 },
        NPI: { required: false, min: 0 },
        License: { required: false, min: 0 }
      },
      specializationList: [],
      subspecializationsList: [],
      specialtiesList: [],
      touched: {
        specialization: false,
        subspecialization: false,
        specialties: false,
        boardCertified: false,
        certdate: false,
        CAQH: false,
        NPI: false,
        License: false
      }

    }
  },
  computed: {
    ...mapGetters('doctorProfile', ['credentials']),
    specialization: {
      get() {
        return this.credentials.specialization || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { specialization: value })
        this.touched.specialization = false
      }
    },

    subspecialization: {
      get() {
        return this.credentials.subSpecialization || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { subSpecialization: value })
        this.touched.subspecialization = false
      }
    },

    specialties: {
      get() {
        return this.credentials.specialties || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { specialties: value })
        this.touched.specialties = false
      }
    },

    boardCertified: {
      get() {
        return this.credentials.ruCertified || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { ruCertified: value })
        this.touched.boardCertified = false
      }
    },

    certdate: {
      get() {
        return this.credentials.certDate
          ? this.credentials.certDate.split('T')[0]
          : null;
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { certDate: value });
        this.touched.certdate = false
      }
    },

    CAQH: {
      get() {
        return this.credentials.CAQH || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { CAQH: value })
        this.touched.CAQH = false
      }
    },

    NPI: {
      get() {
        return this.credentials.NPI || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { NPI: value })
        this.touched.NPI = false
      }
    },

    License: {
      get() {
        return this.credentials.LICENSE || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { LICENSE: value })
        this.touched.License = false
      }
    }
  },
  watch: {
    boardCertified(newVal) {
      this.touched.boardCertified = true
      if (newVal !== "Yes") {
        this.certdate = null
      }
    },
    specialization() {
      this.touched.specialization = true
    },
    subspecialization() {
      this.touched.subspecialization = true
    },
    specialties() {
      this.touched.specialties = true
    },
    certdate() {
      this.touched.certdate = true
    },
    CAQH() {
      this.touched.CAQH = true
    },
    NPI() {
      this.touched.NPI = true
    },
    License() {
      this.touched.License = true
    }
  },
  mounted() {
    this.defineLookups()
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),

    async defineLookups() {
      try {
        const specialization = await this.fetchLookupByName("Qualifications")
        this.specializationList = this.sortByDisplayName(specialization)
        const subSpecialization = await this.fetchLookupByName("Subspecializations")
        this.subspecializationsList = this.sortByDisplayName(subSpecialization)
        const specialties = await this.fetchLookupByName("Specialities")
        this.specialtiesList = this.sortByDisplayName(specialties)
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },

    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },

    sortByDisplayName(arr) {
      return arr.slice().sort((a, b) => a.DisplayValue.localeCompare(b.DisplayValue))
    },

    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res)
        return res
      })
    }
  }
}
</script>
<style>
  :root {
  --gray: #999;
  --blue: #0074d9;
  --color: #333;
  --background-color: #fff;
  --border: 1px solid #eee;
}

  .md-menu-content {
  z-index: 9998 !important;
}
</style>
